import React from 'react';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

const EnvChip = ({ classes, tooltipPlacement = 'bottom' }) => {
  return (
    process.env.REACT_APP_ENV && (
      <Tooltip title="Environment" placement={tooltipPlacement}>
        <Chip className={classes.envChip} label={process.env.REACT_APP_ENV.toUpperCase()} color="secondary" />
      </Tooltip>
    )
  );
};

const styles = theme => ({
  envChip: {
    height: 18,
    color: '#fff',
    marginRight: '8px',
    [theme.breakpoints.down(389)]: {
      fontSize: '0.6rem',
    }
  }
});

export default withStyles(styles)(EnvChip);
